module.exports = __webpack_public_path__ + "static/media/sai-global-logo.0b1158ea.svg";